import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionPlan } from '../../../../projects/client';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'subscriptionPlanTranslation',
  standalone: true,
})
export class SubscriptionPlanTranslationPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(plan: SubscriptionPlan): string | undefined {
    switch (plan) {
      case SubscriptionPlan.Pro:
        return this.translateService.instant('+BOOKING.PLAN.PRO_PACKAGE');
      case SubscriptionPlan.Plus:
        return this.translateService.instant('+BOOKING.PLAN.PLUS_PACKAGE');
      case SubscriptionPlan.Free:
        return this.translateService.instant('+BOOKING.PLAN.FREE_PACKAGE');
      case SubscriptionPlan.Trial:
        return this.translateService.instant('+BOOKING.PLAN.TRIAL_PACKAGE');
      case SubscriptionPlan.Basic:
        return this.translateService.instant('+BOOKING.PLAN.BASIC_PACKAGE');
    }
  }
}
